module.exports = __webpack_public_path__ + "static/media/four_measures.02f1f7d0.png";